import { getApiBaseUrl } from '../utils/apiBaseUrl'

export interface MoveAddressResponse {
    message: string;
    status: boolean;
  }
  
  export const MoveAddressToAddressDeletedTableAsync = async (
    addressId: number,
    token: string
  ): Promise<MoveAddressResponse> => {
    const baseUrl = getApiBaseUrl();
    const apiUrl = `${baseUrl}/api/Admin/MoveAddressToAddressDeletedTableAsync?addressId=${addressId}`;
  
    try {
      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
  
      if (!response.ok) {
        throw new Error(`Failed to move address: ${response.status}`);
      }
  
      return await response.json();
    } catch (error) {
      // console.error("Error in moveAddressToDeletedAsync:", error);
      throw error;
    }
  };
  